var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12"},[_c('user-card'),_c('SystemList')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }